module.exports = {
	"id" : "KYC",
	"name" : "KYC",
	"page" : 1,
	"rules" : [
		{
			"conditions" : {
				"Spouse-Id" : {
					"not": {
						"or": [
							{
								"is": ""
							},
							"undef"
						]						
					}
				}
			},
			"event": {
				"type": "setSpouseReadonly"
			}
		},
		{
			"conditions" : {
				"Contact-FinServ__MaritalStatus__c" : {
					"not" : {
						"or" : [
							{
								"is" : "Married"
							},
							{
								"is" : "Common-Law"
							}
						]
					}
				}
			},
			"event" : {
				"type" : "hideSpouseSection",
				"params" : {
					"field" : [
						"Spouse-FirstName",
						"Spouse-MiddleName",
						"Spouse-LastName",
						"Spouse-Birthdate",
						"Spouse-Id",
						"Account-Is_Spouse_a_Mawer_Client__c",
						"Spouse-Account-Annual_Income__c",
						"Spouse-Employment_Status__c",
						"Spouse-FinServ__Occupation__c",
						"Spouse-FinServ__CurrentEmployer__c",
						"Spouse-Employer_Address__c",
						"SpousalPartnerInformationBanner"
					]
				}
			}
		},
		{
			"conditions" : {
				"Contact-FinServ__MaritalStatus__c" : {
					"or" : [
						{
							"is" : "Married"
						},
						{
							"is" : "Common-Law"
						}
					]
				}
			},
			"event" : {
				"type" : "showSpouseSection",
				"params" : {
					"field" : [
						"Spouse-FirstName",
						"Spouse-MiddleName",
						"Spouse-LastName",
						"Spouse-Birthdate",
						"Spouse-Id",
						"Account-Is_Spouse_a_Mawer_Client__c",
						"Spouse-Account-Annual_Income__c",
						"Spouse-Employment_Status__c",
						"Spouse-FinServ__Occupation__c",
						"Spouse-FinServ__CurrentEmployer__c",
						"Spouse-Employer_Address__c",
						"SpousalPartnerInformationBanner"
					]
				}
			}
		},
		{
			"conditions" : {
				"Contact-FinServ__MaritalStatus__c" : {
					"or" : [
						{
							"is" : "Married"
						},
						{
							"is" : "Common-Law"
						}
					]
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Spouse-FirstName",
						"Spouse-LastName",
						"Account-Is_Spouse_a_Mawer_Client__c"
					]
				}
			}
		},
		{
			"conditions": {
				"Account-BillingCountry": {
					"or" : [
						{
							"is" : "Canada"
						},
						{
							"is" : "United States"
						}
					]
				}
			},
			"event": {
				"type": "require",
				"params" : {
					"field" : [
						"Account-BillingState"
					]
				}
			}
		},
		{
			"conditions": {
				"Account-Annual_Income__c": "undef"
			},
			"event": {
				"type": "require",
				"params" : {
					"field" : [
						"Account-Annual_Income__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-Is_Spouse_a_Mawer_Client__c" : {
					"is": false
				},
				"Contact-FinServ__MaritalStatus__c" : {
					"or" : [
						{
							"is" : "Married"
						},
						{
							"is" : "Common-Law"
						}
					]
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Spouse-Employment_Status__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-Is_Spouse_a_Mawer_Client__c" : {
					"or" : [
						{
							"is": true
						},
						"undef"
					]
				},
				"Contact-FinServ__MaritalStatus__c" : {
					"or" : [
						{
							"is" : "Married"
						},
						{
							"is" : "Common-Law"
						}
					]
				}
			},
			"event" : {
				"type" : "remove",
				"params" : {
					"field" : [
						"Spouse-Account-Annual_Income__c",
						"Spouse-Employment_Status__c"
					]
				}
			}
		},
		{
			"conditions": {
				"Account-Is_Spouse_a_Mawer_Client__c" : {
					"is": false
				},
				"Contact-FinServ__MaritalStatus__c" : {
					"or" : [
						{
							"is" : "Married"
						},
						{
							"is" : "Common-Law"
						}
					]
				}
			},
			"event": {
				"type": "require",
				"params" : {
					"field" : [
						"Spouse-Account-Annual_Income__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-Is_Spouse_a_Mawer_Client__c" : {
					"is": false
				},
				"Contact-FinServ__MaritalStatus__c" : {
					"or" : [
						{
							"is" : "Married"
						},
						{
							"is" : "Common-Law"
						}
					]
				},
				"Spouse-Employment_Status__c" : {
					"or" : [
						{
							"is" : "Self-Employed"
						},
						{
							"is" : "Employed"
						},
						{
							"is" : "Retired"
						}
					]
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Spouse-FinServ__Occupation__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-Is_Spouse_a_Mawer_Client__c" : {
					"is": false
				},
				"Contact-FinServ__MaritalStatus__c" : {
					"or" : [
						{
							"is" : "Married"
						},
						{
							"is" : "Common-Law"
						}
					]
				},
				"Spouse-Employment_Status__c" : {
					"or" : [
						{
							"is" : "Self-Employed"
						},
						{
							"is" : "Employed"
						}
					]
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Spouse-FinServ__CurrentEmployer__c",
						"Spouse-Employer_Address__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Spouse-Employment_Status__c" : {
					"is" : "Retired"
				}
			},
			"event" : {
				"type" : "replaceLabel",
				"params" : {
					"fields" : [
						{ id: "Spouse-FinServ__CurrentEmployer__c", newLabel: "Spouse's Previous Employer Name"},
						{ id: "Spouse-FinServ__Occupation__c", newLabel: "Spouse's Previous Occupation"},
						{ id: "Spouse-Employer_Address__c", newLabel: "Spouse's Previous Employer's City / Province or State" }
					]
				}
			}
		},
		{
			"conditions" : {
				"or": [
					{
						"Account-Is_Spouse_a_Mawer_Client__c" : {
							"or" : [
								{
									"is": true
								},
								"undef"
							]
						}
					},
					{
						"Contact-FinServ__MaritalStatus__c" : {
							"not" : {
								"or" : [
									{
										"is" : "Married"
									},
									{
										"is" : "Common-Law"
									}
								]
							}
						}
					},
					{
						"Spouse-Employment_Status__c" : "falsey"
					}
				]				
			},
			"event" : {
				"type" : "remove",
				"params" : {
					"field" : [
						"Spouse-FinServ__CurrentEmployer__c",
						"Spouse-FinServ__Occupation__c",
						"Spouse-Employer_Address__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Contact-Employment_Status__c" : {
					"or" : [
						{
							"is" : "Self-Employed"
						},
						{
							"is" : "Employed"
						},
						{
							"is" : "Retired"
						}
					]
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Contact-FinServ__Occupation__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Contact-Employment_Status__c" : {
					"or" : [
						{
							"is" : "Self-Employed"
						},
						{
							"is" : "Employed"
						}
					]
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Contact-FinServ__CurrentEmployer__c",
						"Contact-Employer_Address__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Contact-Employment_Status__c" : {
					"is" : "Retired"
				}
			},
			"event" : {
				"type" : "replaceLabel",
				"params" : {
					"fields" : [
						{ id: "Contact-FinServ__CurrentEmployer__c", newLabel: "Previous Employer Name"},
						{ id: "Contact-FinServ__Occupation__c", newLabel: "Previous Occupation"},
						{ id: "Contact-Employer_Address__c", newLabel: "Previous Employer's City / Province or State" }
					]
				}
			}
		},
		{
			"conditions" : {
				"Contact-Primary_Phone_Number__c" : {
					"is" : "Home"
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Contact-HomePhone"
					]
				}
			}
		},
		{
			"conditions" : {
				"Contact-Primary_Phone_Number__c" : {
					"is" : "Business"
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Contact-Phone"
					]
				}
			}
		},
		{
			"conditions" : {
				"Contact-Primary_Phone_Number__c" : {
					"is" : "Cell"
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Contact-MobilePhone"
					]
				}
			}
		},
		{
			"conditions" : {
				"Contact-Primary_Phone_Number__c" : {
					"is" : "Other"
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Contact-OtherPhone"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-Is_Mailing_Address_Different__c" : {
					"is" : true
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Account-ShippingStreet",
						"Account-ShippingCity",
						"Account-ShippingState",
						"Account-ShippingCountry",
						"Account-ShippingPostalCode"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-Is_Mailing_Address_Different__c" : {
					"is" : false
				}
			},
			"event" : {
				"type" : "remove",
				"params" : {
					"field" : [
						"Account-ShippingStreet",
						"Account-ShippingCity",
						"Account-ShippingState",
						"Account-ShippingCountry",
						"Account-ShippingPostalCode"
					]
				}
			}
		}
	],
	"uiSchema" : {
		"Contact-Id" : {
			"ui:widget" : "hidden"
		},
		"Account-Id" : {
			"ui:widget" : "hidden"
		},
		"Spouse-Id" : {
			"ui:widget" : "hidden"
		},
		"PersonalInformationBanner" : {
			"header" : "Personal Information",
			"classNames" : "full-column",
			"ui:widget" : "hidden"
		},
		"Contact-Salutation" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Contact-FirstName" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Contact-MiddleName" : {
			"wrapperClassNames" : "col-xs-2 col-md-3",
			"ui:emptyValue": ""
		},
		"Contact-LastName" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Contact-Tax_ID__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3",
			"ui:widget": "sinInput"
		},
		"Contact-FinServ__MaritalStatus__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Contact-Birthdate" : {
			"wrapperClassNames" : "col-xs-2 col-md-3",
			"ui:widget" : "materialDatePicker"
		},
		"Contact-FinServ__NumberOfDependents__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Contact-Citizenship__c" : {
			"classNames" : "col-xs-2 col-md-6",
			// "$ref" : "#/definitions/multipleCountries",
			"ui:field" : "asyncTypeAhead",
			"asyncTypeahead" : {
				"id" : "Contact-Citizenship__c",
				"url" : "/api/value/country",
				"multiple" : true
			}
		},
		"AccountInformationBanner" : {
			"header" : "Address Information",
			"classNames" : "full-column",
			"ui:widget" : "hidden"
		},
		"Account-BillingStreet" : {
			"classNames" : "col-xs-2 col-md-4",
			"ui:widget" : "addressInput"
		},
		"Account-BillingCity" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Account-BillingState" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Account-BillingCountry" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Account-BillingPostalCode" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Account-ShippingStreet" : {
			"classNames" : "col-xs-2 col-md-4",
			"ui:widget" : "addressInput"
		},
		"Account-ShippingCity" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Account-ShippingState" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Account-ShippingCountry" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Account-ShippingPostalCode" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"ContactDetailsBanner" : {
			"header" : "Contact Details",
			"classNames" : "full-column",
			"ui:widget" : "hidden"
		},
		"Contact-Primary_Phone_Number__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Contact-HomePhone" : {
			"wrapperClassNames" : "col-xs-2 col-md-3",
			"ui:widget": "phoneNumberInput"
		},
		"Contact-Phone" : {
			"wrapperClassNames" : "col-xs-2 col-md-3",
			"ui:widget": "phoneNumberInput"
		},
		"Contact-MobilePhone" : {
			"wrapperClassNames" : "col-xs-2 col-md-3",
			"ui:widget": "phoneNumberInput"
		}, 
		"Contact-OtherPhone" : {
			"wrapperClassNames" : "col-xs-2 col-md-3 other-phone",
			"ui:emptyValue": ""
		},
		"Contact-Email" : {
			"classNames" : "full-column col-xs-2 col-md-3",
			"ui:help": "*This email address will be used as client's portal login."
		},
		"SpousalPartnerInformationBanner" : {
			"header" : "Spouse/Partner Information",
			"ui:widget" : "hidden",
			"classNames" : "full-column"
		},
		"Spouse-FirstName" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Spouse-MiddleName" : {
			"wrapperClassNames" : "col-xs-2 col-md-3",
			"ui:emptyValue": ""
		},
		"Spouse-LastName" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"Spouse-Birthdate" : {
			"wrapperClassNames" : "col-xs-2 col-md-3",
			"ui:widget" : "materialDatePicker"
		},
		"FinancialInformationBanner" : {
			"header" : "Employment Information",
			"classNames" : "full-column",
			"ui:widget" : "hidden"
		},
		"Account-Annual_Income__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4",
			"ui:widget": "currencyNumberFormat"
		},
		"Contact-Employment_Status__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4"
		},
		"Contact-FinServ__Occupation__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4",
			"ui:title" : "Occupation"
		},
		"Contact-FinServ__CurrentEmployer__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4",
			"ui:title" : "Employer Name",
		},
		"Contact-Employer_Address__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4",
			"ui:title" : "Employer's City / Province or State"
		},
		"Account-Is_Spouse_a_Mawer_Client__c" : {
			"ui:widget" : "radio"
		},
		"Spouse-Account-Annual_Income__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4",
			"ui:widget": "currencyNumberFormat"
		},
		"Spouse-Employment_Status__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-8",
			"classNames" : "col-xs-12 col-md-6"
		},
		"Spouse-FinServ__Occupation__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4",
			"ui:title" : "Spouse Occupation"
		},
		"Spouse-FinServ__CurrentEmployer__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4",
			"ui:title" : "Spouse Employer Name"
		},
		"Spouse-Employer_Address__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4",
			"ui:title" : "Spouse Employer's City / Province or State"
		}
	},
	"schema" : {
		"required" : [
			"Contact-FirstName",
			"Contact-LastName",
			"Contact-Birthdate",
			"Contact-Tax_ID__c",
			"Contact-Citizenship__c",
			"Contact-FinServ__MaritalStatus__c",
			"Contact-FinServ__NumberOfDependents__c",
			"Contact-Primary_Phone_Number__c",
			"Contact-Employment_Status__c",
			"Account-BillingStreet",
			"Account-BillingCity",
			"Account-BillingCountry",
			"Account-BillingPostalCode",
		],
		"title" : "Client Details",
		"type" : "object",
		"root" : true,
		"properties" : {
			"Account-Id" : {
				"type" : "string"
			},
			"Contact-Id" : {
				"type" : "string"
			},
			"Spouse-Id" : {
				"type" : "string"
			},
			"PersonalInformationBanner" : {
				"type" : "null"
			},
			"Contact-Salutation" : {
				"root" : true,
				"title" : "Salutation",
				"enum" : [
					"Mr.",
					"Mrs.",
					"Ms.",
					"Miss",
					"Dr.",
					"Prof.",
					"Alderman",
					"Justice",
					"Sr.",
					"The Honourable",
					"Father",
					"Reverand",
					"Sister"				
				],
				"ui:emptyValue": ""
			},
			"Contact-FirstName" : {
				"title" : "First Name",
				"type" : "string",
				"readOnly": true
			},
			"Contact-MiddleName" : {
				"title" : "Middle Name",
				"type" : "string",
				"ui:emptyValue": ""
			},
			"Contact-LastName" : {
				"title" : "Last Name",
				"type" : "string",
				"readOnly": true
			},
			"Contact-Birthdate" : {
				"title" : "Date of Birth",
				"type" : "string",
				"format" : "date"
			},
			"Contact-Tax_ID__c" : {
				"title" : "Social Insurance Number/ Tax ID",
				"type" : "string"
			},
			"Contact-FinServ__MaritalStatus__c" : {
				"title" : "Marital Status",
				"enum" : [
					"Single",
					"Married",
					"Separated",
					"Divorced",
					"Widowed",
					"Common-Law"
				]
			},
			"Contact-FinServ__NumberOfDependents__c" : {
				"type" : "number",
				"title" : "Number of Dependents",
				"minimum" : 0
			},
			"Contact-Citizenship__c" : {
				"$ref" : "#/definitions/multipleCountries",
				"title" : "Citizenship"
			},
			"AccountInformationBanner" : {
				"type" : "null"
			},
			"Account-BillingStreet" : {
				"type" : "string",
				"title" : "Primary Address"
			},
			"Account-BillingCity" : {
				"title" : "City",
				"type" : "string"
			},
			"Account-BillingState" : {
				"title" : "Province/State",
				"$ref" : "#/definitions/provinces"
			},
			"Account-BillingCountry" : {
				"$ref" : "#/definitions/countries"
			},
			"Account-BillingPostalCode" : {
				"title" : "Postal/Zip Code",
				"type" : "string"
			},
			"Account-Is_Mailing_Address_Different__c" : {
				"title" : "Is Mailing Address different from the Permanent/Legal Address?",
				"type" : "boolean",
				"default" : false
			},
			"Account-ShippingStreet" : {
				"type" : "string",
				"title" : "Mailing Street Address"
			},
			"Account-ShippingCity" : {
				"title" : "City",
				"type" : "string"
			},
			"Account-ShippingState" : {
				"title" : "Province/State",
				"$ref" : "#/definitions/provinces"
			},
			"Account-ShippingCountry" : {
				"$ref" : "#/definitions/countries"
			},
			"Account-ShippingPostalCode" : {
				"title" : "Postal/Zip Code",
				"type" : "string"
			},
			"ContactDetailsBanner" : {
				"type" : "null"
			},
			"Contact-Primary_Phone_Number__c" : {
				"title" : "Which is your primary phone number?",
				"enum" : [
					"Home",
					"Cell",
					"Business",
					"Other"
				]
			},
			"Contact-HomePhone" : {
				"title" : "Home Phone",
				"type" : "string"
			},
			"Contact-MobilePhone" : {
				"title" : "Cell Phone",
				"type" : "string"
			},
			"Contact-Phone" : {
				"title" : "Business Phone",
				"type" : "string"
			},
			"Contact-OtherPhone": {
				"title" : "Other Phone",
				"type" : "string"
			},
			"Contact-Email" : {
				"type" : "string",
				"title" : "Email",
				"format" : "email"
			},
			"FinancialInformationBanner" : {
				"type" : "null"
			},
			"Account-Annual_Income__c" : {
				"title" : "Approximate Annual Income (gross)",
				"type" : "number",
				"minimum" : 0
			},
			"Contact-Employment_Status__c" : {
				"title" : "Employment Status",
				"enum" : [
					"Employed",
					"Self-Employed",
					"Retired",
					"Homemaker",
					"Student",
					"Not Employed"
				]
			},
			"Contact-FinServ__Occupation__c" : {
				"root" : true,
				"type" : "string"
			},
			"Contact-FinServ__CurrentEmployer__c" : {
				"type" : "string"
			},
			"Contact-Employer_Address__c" : {
				"type" : "string"
			},
			"SpousalPartnerInformationBanner" : {
				"type" : "null"
			},
			"Spouse-FirstName" : {
				"title" : "First Name",
				"type" : "string"
			},
			"Spouse-MiddleName" : {
				"title" : "Middle Name",
				"type" : "string"
			},
			"Spouse-LastName" : {
				"title" : "Last Name",
				"type" : "string"
			},
			"Spouse-Birthdate" : {
				"title" : "Date of Birth",
				"type" : ["string", "null"]
			},
			"Account-Is_Spouse_a_Mawer_Client__c" : {
				"title" : "Is your spouse also a Mawer client?",
				"$ref" : "#/definitions/yesNoCheckbox"
			},
			"Spouse-Account-Annual_Income__c" : {
				"title" : "Spouse Approximate Annual Income (Gross)",
				"type" : "number",
				"minimum" : 0
			},
			"Spouse-Employment_Status__c" : {
				"title" : "Spouse Employment Status",
				"enum" : [
					"Employed",
					"Self-Employed",
					"Retired",
					"Homemaker",
					"Student",
					"Not Employed"
				]
			},
			"Spouse-FinServ__Occupation__c" : {
				"root" : true,
				"type" : "string"
			},
			"Spouse-FinServ__CurrentEmployer__c" : {
				"type" : "string"
			},
			"Spouse-Employer_Address__c" : {
				"type" : "string"
			}
		},
		"definitions" : {
			"yesNoCheckbox" : {
				"type" : "boolean",
				"oneOf" : [
					{
						"const" : true,
						"title" : "Yes"
					},
					{
						"const" : false,
						"title" : "No"
					}
				]
			},
			"assetAndLiabilities" : {
				"type" : "object",
				"properties" : {
					"id" : {
						"type" : "string"
					}
				}
			},
			"multipleCountries" : {
				"title" : "Country",
				"type" : "array",
				"items" : {
					"type" : "string",
					"enum" : [
						"Afghanistan",
						"Albania",
						"Algeria",
						"Andorra",
						"Angola",
						"Anguilla",
						"Antigua & Barbuda",
						"Argentina",
						"Armenia",
						"Aruba",
						"Australia",
						"Austria",
						"Azerbaijan",
						"Bahamas",
						"Bahrain",
						"Bangladesh",
						"Barbados",
						"Belarus",
						"Belgium",
						"Belize",
						"Benin",
						"Bermuda",
						"Bhutan",
						"Bolivia",
						"Bosnia & Herzegovina",
						"Botswana",
						"Brazil",
						"British Virgin Islands",
						"Brunei",
						"Bulgaria",
						"Burkina Faso",
						"Burundi",
						"Cambodia",
						"Cameroon",
						"Canada",
						"Cape Verde",
						"Cayman Islands",
						"Chad",
						"Chile",
						"China",
						"Colombia",
						"Congo",
						"Cook Islands",
						"Costa Rica",
						"Cote D Ivoire",
						"Croatia",
						"Cruise Ship",
						"Cuba",
						"Cyprus",
						"Czech Republic",
						"Denmark",
						"Djibouti",
						"Dominica",
						"Dominican Republic",
						"Ecuador",
						"Egypt",
						"El Salvador",
						"Equatorial Guinea",
						"Estonia",
						"Ethiopia",
						"Falkland Islands",
						"Faroe Islands",
						"Fiji",
						"Finland",
						"France",
						"French Polynesia",
						"French West Indies",
						"Gabon",
						"Gambia",
						"Georgia",
						"Germany",
						"Ghana",
						"Gibraltar",
						"Greece",
						"Greenland",
						"Grenada",
						"Guam",
						"Guatemala",
						"Guernsey",
						"Guinea",
						"Guinea Bissau",
						"Guyana",
						"Haiti",
						"Honduras",
						"Hong Kong",
						"Hungary",
						"Iceland",
						"India",
						"Indonesia",
						"Iran",
						"Iraq",
						"Ireland",
						"Isle of Man",
						"Israel",
						"Italy",
						"Jamaica",
						"Japan",
						"Jersey",
						"Jordan",
						"Kazakhstan",
						"Kenya",
						"Kuwait",
						"Kyrgyz Republic",
						"Laos",
						"Latvia",
						"Lebanon",
						"Lesotho",
						"Liberia",
						"Libya",
						"Liechtenstein",
						"Lithuania",
						"Luxembourg",
						"Macau",
						"Macedonia",
						"Madagascar",
						"Malawi",
						"Malaysia",
						"Maldives",
						"Mali",
						"Malta",
						"Mauritania",
						"Mauritius",
						"Mexico",
						"Moldova",
						"Monaco",
						"Mongolia",
						"Montenegro",
						"Montserrat",
						"Morocco",
						"Mozambique",
						"Namibia",
						"Nepal",
						"Netherlands",
						"Netherlands Antilles",
						"New Caledonia",
						"New Zealand",
						"Nicaragua",
						"Niger",
						"Nigeria",
						"Norway",
						"Oman",
						"Pakistan",
						"Palestine",
						"Panama",
						"Papua New Guinea",
						"Paraguay",
						"Peru",
						"Philippines",
						"Poland",
						"Portugal",
						"Puerto Rico",
						"Qatar",
						"Reunion",
						"Romania",
						"Russia",
						"Rwanda",
						"Saint Pierre & Miquelon",
						"Samoa",
						"San Marino",
						"Satellite",
						"Saudi Arabia",
						"Senegal",
						"Serbia",
						"Seychelles",
						"Sierra Leone",
						"Singapore",
						"Slovakia",
						"Slovenia",
						"South Africa",
						"South Korea",
						"Spain",
						"Sri Lanka",
						"St Kitts & Nevis",
						"St Lucia",
						"St Vincent",
						"St. Lucia",
						"Sudan",
						"Suriname",
						"Swaziland",
						"Sweden",
						"Switzerland",
						"Syria",
						"Taiwan",
						"Tajikistan",
						"Tanzania",
						"Thailand",
						"Timor L'Este",
						"Togo",
						"Tonga",
						"Trinidad & Tobago",
						"Tunisia",
						"Turkey",
						"Turkmenistan",
						"Turks & Caicos",
						"Uganda",
						"Ukraine",
						"United Arab Emirates",
						"United Kingdom",
						"United States of America",
						"United States Minor Outlying Islands",
						"Uruguay",
						"Uzbekistan",
						"Venezuela",
						"Vietnam",
						"Virgin Islands (US)",
						"Yemen",
						"Zambia",
						"Zimbabwe"
					]
				},
				"uniqueItems" : true
			},
			"countries" : {
				"title" : "Country",
				"type" : "string",
				"enum" : [
					"United States of America",
					"Canada",
					"Afghanistan",
					"Aland Islands",
					"Albania",
					"Algeria",
					"Andorra",
					"Angola",
					"Anguilla",
					"Antarctica",
					"Antigua and Barbuda",
					"Argentina",
					"Armenia",
					"Aruba",
					"Australia",
					"Austria",
					"Azerbaijan",
					"Bahamas",
					"Bahrain",
					"Bangladesh",
					"Barbados",
					"Belarus",
					"Belgium",
					"Belize",
					"Benin",
					"Bermuda",
					"Bhutan",
					"Bolivia, Plurinational State of",
					"Bonaire, Sint Eustatius and Saba",
					"Bosnia and Herzegovina",
					"Botswana",
					"Bouvet Island",
					"Brazil",
					"British Indian Ocean Territory",
					"Brunei Darussalam",
					"Bulgaria",
					"Burkina Faso",
					"Burundi",
					"Cambodia",
					"Cameroon",
					"Cape Verde",
					"Cayman Islands",
					"Central African Republic",
					"Chad",
					"Chile",
					"China",
					"Christmas Island",
					"Cocos (Keeling) Islands",
					"Colombia",
					"Comoros",
					"Congo",
					"Congo, the Democratic Republic of the",
					"Cook Islands",
					"Costa Rica",
					"Cote d’Ivoire",
					"Croatia",
					"Cuba",
					"Curaçao",
					"Cyprus",
					"Czech Republic",
					"Denmark",
					"Djibouti",
					"Dominica",
					"Dominican Republic",
					"Ecuador",
					"Egypt",
					"El Salvador",
					"Equatorial Guinea",
					"Eritrea",
					"Estonia",
					"Ethiopia",
					"Falkland Islands (Malvinas)",
					"Faroe Islands",
					"Fiji",
					"Finland",
					"France",
					"French Guiana",
					"French Polynesia",
					"French Southern Territories",
					"Gabon",
					"Gambia",
					"Georgia",
					"Germany",
					"Ghana",
					"Gibraltar",
					"Greece",
					"Greenland",
					"Grenada",
					"Guadeloupe",
					"Guatemala",
					"Guernsey",
					"Guinea",
					"Guinea-Bissau",
					"Guyana",
					"Haiti",
					"Heard Island and McDonald Islands",
					"Holy See (Vatican City State)",
					"Honduras",
					"Hungary",
					"Iceland",
					"India",
					"Indonesia",
					"Iran, Islamic Republic of",
					"Iraq",
					"Ireland",
					"Isle of Man",
					"Israel",
					"Italy",
					"Jamaica",
					"Japan",
					"Jersey",
					"Jordan",
					"Kazakhstan",
					"Kenya",
					"Kiribati",
					"Korea, Democratic People’s Republic of",
					"Korea, Republic of",
					"Kuwait",
					"Kyrgyzstan",
					"Lao People’s Democratic Republic",
					"Latvia",
					"Lebanon",
					"Lesotho",
					"Liberia",
					"Libyan Arab Jamahiriya",
					"Liechtenstein",
					"Lithuania",
					"Luxembourg",
					"Macao",
					"Macedonia, the former Yugoslav Republic of",
					"Madagascar",
					"Malawi",
					"Malaysia",
					"Maldives",
					"Mali",
					"Malta",
					"Martinique",
					"Mauritania",
					"Mauritius",
					"Mayotte",
					"Mexico",
					"Moldova, Republic of",
					"Monaco",
					"Mongolia",
					"Montenegro",
					"Montserrat",
					"Morocco",
					"Mozambique",
					"Myanmar",
					"Namibia",
					"Nauru",
					"Nepal",
					"Netherlands",
					"New Caledonia",
					"New Zealand",
					"Nicaragua",
					"Niger",
					"Nigeria",
					"Niue",
					"Norfolk Island",
					"Norway",
					"Oman",
					"Pakistan",
					"Palestine",
					"Panama",
					"Papua New Guinea",
					"Paraguay",
					"Peru",
					"Philippines",
					"Pitcairn",
					"Poland",
					"Portugal",
					"Qatar",
					"Reunion",
					"Romania",
					"Russian Federation",
					"Rwanda",
					"Saint Barthélemy",
					"Saint Helena, Ascension and Tristan da Cunha",
					"Saint Kitts and Nevis",
					"Saint Lucia",
					"Saint Martin (French part)",
					"Saint Pierre and Miquelon",
					"Saint Vincent and the Grenadines",
					"Samoa",
					"San Marino",
					"Sao Tome and Principe",
					"Saudi Arabia",
					"Senegal",
					"Serbia",
					"Seychelles",
					"Sierra Leone",
					"Singapore",
					"Sint Maarten (Dutch part)",
					"Slovakia",
					"Slovenia",
					"Solomon Islands",
					"Somalia",
					"South Africa",
					"South Georgia and the South Sandwich Islands",
					"South Sudan",
					"Spain",
					"Sri Lanka",
					"Sudan",
					"Suriname",
					"Svalbard and Jan Mayen",
					"Swaziland",
					"Sweden",
					"Switzerland",
					"Syrian Arab Republic",
					"Taiwan",
					"Tajikistan",
					"Tanzania, United Republic of",
					"Thailand",
					"Timor-Leste",
					"Togo",
					"Tokelau",
					"Tonga",
					"Trinidad and Tobago",
					"Tunisia",
					"Turkey",
					"Turkmenistan",
					"Turks and Caicos Islands",
					"Tuvalu",
					"Uganda",
					"Ukraine",
					"United Arab Emirates",
					"United Kingdom",
					"Uruguay",
					"Uzbekistan",
					"Vanuatu",
					"Venezuela, Bolivarian Republic of",
					"Vietnam",
					"Virgin Islands, British",
					"Wallis and Futuna",
					"Western Sahara",
					"Yemen",
					"Zambia",
					"Zimbabwe"
				]
			},
			"provinces" : {
				"title" : "Province/State",
				"type" : "string",
				"anyOf" : [
					{
						"type" : "string",
						"title" : "Alberta",
						"enum" : [
							"Alberta"
						]
					},
					{
						"type" : "string",
						"title" : "British Columbia",
						"enum" : [
							"British Columbia"
						]
					},
					{
						"type" : "string",
						"title" : "Manitoba",
						"enum" : [
							"Manitoba"
						]
					},
					{
						"type" : "string",
						"title" : "New Brunswick",
						"enum" : [
							"New Brunswick"
						]
					},
					{
						"type" : "string",
						"title" : "Newfoundland and Labrador",
						"enum" : [
							"Newfoundland and Labrador"
						]
					},
					{
						"type" : "string",
						"title" : "Northwest Territories",
						"enum" : [
							"Northwest Territories"
						]
					},
					{
						"type" : "string",
						"title" : "Nova Scotia",
						"enum" : [
							"Nova Scotia"
						]
					},
					{
						"type" : "string",
						"title" : "Nunavut",
						"enum" : [
							"Nunavut"
						]
					},
					{
						"type" : "string",
						"title" : "Ontario",
						"enum" : [
							"Ontario"
						]
					},
					{
						"type" : "string",
						"title" : "Prince Edward Island",
						"enum" : [
							"Prince Edward Island"
						]
					},
					{
						"type" : "string",
						"title" : "Quebec",
						"enum" : [
							"Quebec"
						]
					},
					{
						"type" : "string",
						"title" : "Saskatchewan",
						"enum" : [
							"Saskatchewan"
						]
					},
					{
						"type" : "string",
						"title" : "Yukon Territories",
						"enum" : [
							"Yukon Territories"
						]
					},
					{
						"type" : "string",
						"title" : "Alabama",
						"enum" : [
							"Alabama"
						]
					},
					{
						"type" : "string",
						"title" : "Alaska",
						"enum" : [
							"Alaska"
						]
					},
					{
						"type" : "string",
						"title" : "American Samoa",
						"enum" : [
							"American Samoa"
						]
					},
					{
						"type" : "string",
						"title" : "Arizona",
						"enum" : [
							"Arizona"
						]
					},
					{
						"type" : "string",
						"title" : "Arkansas",
						"enum" : [
							"Arkansas"
						]
					},
					{
						"type" : "string",
						"title" : "California",
						"enum" : [
							"California"
						]
					},
					{
						"type" : "string",
						"title" : "Colorado",
						"enum" : [
							"Colorado"
						]
					},
					{
						"type" : "string",
						"title" : "Connecticut",
						"enum" : [
							"Connecticut"
						]
					},
					{
						"type" : "string",
						"title" : "Delaware",
						"enum" : [
							"Delaware"
						]
					},
					{
						"type" : "string",
						"title" : "District Of Columbia",
						"enum" : [
							"District Of Columbia"
						]
					},
					{
						"type" : "string",
						"title" : "Federated States Of Micronesia",
						"enum" : [
							"Federated States Of Micronesia"
						]
					},
					{
						"type" : "string",
						"title" : "Florida",
						"enum" : [
							"Florida"
						]
					},
					{
						"type" : "string",
						"title" : "Georgia",
						"enum" : [
							"Georgia"
						]
					},
					{
						"type" : "string",
						"title" : "Guam",
						"enum" : [
							"Guam"
						]
					},
					{
						"type" : "string",
						"title" : "Hawaii",
						"enum" : [
							"Hawaii"
						]
					},
					{
						"type" : "string",
						"title" : "Idaho",
						"enum" : [
							"Idaho"
						]
					},
					{
						"type" : "string",
						"title" : "Illinois",
						"enum" : [
							"Illinois"
						]
					},
					{
						"type" : "string",
						"title" : "Indiana",
						"enum" : [
							"Indiana"
						]
					},
					{
						"type" : "string",
						"title" : "Iowa",
						"enum" : [
							"Iowa"
						]
					},
					{
						"type" : "string",
						"title" : "Kansas",
						"enum" : [
							"Kansas"
						]
					},
					{
						"type" : "string",
						"title" : "Kentucky",
						"enum" : [
							"Kentucky"
						]
					},
					{
						"type" : "string",
						"title" : "Louisiana",
						"enum" : [
							"Louisiana"
						]
					},
					{
						"type" : "string",
						"title" : "Maine",
						"enum" : [
							"Maine"
						]
					},
					{
						"type" : "string",
						"title" : "Marshall Islands",
						"enum" : [
							"Marshall Islands"
						]
					},
					{
						"type" : "string",
						"title" : "Maryland",
						"enum" : [
							"Maryland"
						]
					},
					{
						"type" : "string",
						"title" : "Massachusetts",
						"enum" : [
							"Massachusetts"
						]
					},
					{
						"type" : "string",
						"title" : "Michigan",
						"enum" : [
							"Michigan"
						]
					},
					{
						"type" : "string",
						"title" : "Minnesota",
						"enum" : [
							"Minnesota"
						]
					},
					{
						"type" : "string",
						"title" : "Mississippi",
						"enum" : [
							"Mississippi"
						]
					},
					{
						"type" : "string",
						"title" : "Missouri",
						"enum" : [
							"Missouri"
						]
					},
					{
						"type" : "string",
						"title" : "Montana",
						"enum" : [
							"Montana"
						]
					},
					{
						"type" : "string",
						"title" : "Nebraska",
						"enum" : [
							"Nebraska"
						]
					},
					{
						"type" : "string",
						"title" : "Nevada",
						"enum" : [
							"Nevada"
						]
					},
					{
						"type" : "string",
						"title" : "New Hampshire",
						"enum" : [
							"New Hampshire"
						]
					},
					{
						"type" : "string",
						"title" : "New Jersey",
						"enum" : [
							"New Jersey"
						]
					},
					{
						"type" : "string",
						"title" : "New Mexico",
						"enum" : [
							"New Mexico"
						]
					},
					{
						"type" : "string",
						"title" : "New York",
						"enum" : [
							"New York"
						]
					},
					{
						"type" : "string",
						"title" : "North Carolina",
						"enum" : [
							"North Carolina"
						]
					},
					{
						"type" : "string",
						"title" : "North Dakota",
						"enum" : [
							"North Dakota"
						]
					},
					{
						"type" : "string",
						"title" : "Northern Mariana Islands",
						"enum" : [
							"Northern Mariana Islands"
						]
					},
					{
						"type" : "string",
						"title" : "Ohio",
						"enum" : [
							"Ohio"
						]
					},
					{
						"type" : "string",
						"title" : "Oklahoma",
						"enum" : [
							"Oklahoma"
						]
					},
					{
						"type" : "string",
						"title" : "Oregon",
						"enum" : [
							"Oregon"
						]
					},
					{
						"type" : "string",
						"title" : "Palau",
						"enum" : [
							"Palau"
						]
					},
					{
						"type" : "string",
						"title" : "Pennsylvania",
						"enum" : [
							"Pennsylvania"
						]
					},
					{
						"type" : "string",
						"title" : "Puerto Rico",
						"enum" : [
							"Puerto Rico"
						]
					},
					{
						"type" : "string",
						"title" : "Rhode Island",
						"enum" : [
							"Rhode Island"
						]
					},
					{
						"type" : "string",
						"title" : "South Carolina",
						"enum" : [
							"South Carolina"
						]
					},
					{
						"type" : "string",
						"title" : "South Dakota",
						"enum" : [
							"South Dakota"
						]
					},
					{
						"type" : "string",
						"title" : "Tennessee",
						"enum" : [
							"Tennessee"
						]
					},
					{
						"type" : "string",
						"title" : "Texas",
						"enum" : [
							"Texas"
						]
					},
					{
						"type" : "string",
						"title" : "Utah",
						"enum" : [
							"Utah"
						]
					},
					{
						"type" : "string",
						"title" : "Vermont",
						"enum" : [
							"Vermont"
						]
					},
					{
						"type" : "string",
						"title" : "Virgin Islands",
						"enum" : [
							"Virgin Islands"
						]
					},
					{
						"type" : "string",
						"title" : "Virginia",
						"enum" : [
							"Virginia"
						]
					},
					{
						"type" : "string",
						"title" : "Washington",
						"enum" : [
							"Washington"
						]
					},
					{
						"type" : "string",
						"title" : "West Virginia",
						"enum" : [
							"West Virginia"
						]
					},
					{
						"type" : "string",
						"title" : "Wisconsin",
						"enum" : [
							"Wisconsin"
						]
					},
					{
						"type" : "string",
						"title" : "Wyoming",
						"enum" : [
							"Wyoming"
						]
					}
				]
			}
		}
	}
};